<div class="flex gap-8">
  <input
    #dateInput
    type="text"
    class="w-[118px] text-center outline-none bg-base-transparent"
    [autoSlashDateInput]="currentDateFormat"
    [matDatepicker]="datepicker"
    [min]="min()"
    [max]="max()"
    [ngModel]="internalValue()"
    [placeholder]="placeholder()"
    (click)="openDatePicker()"
    (ngModelChange)="onDateChange($event)"
  />
  <mat-icon
    svgIcon="icon_field_input_date_24"
    class="icon-24 !text-primary-lighter mt-2"
    (click)="openDatePicker()"
  />
  <mat-datepicker
    #datepicker
    panelClass="bl-datepicker with-theme"
    [startView]="'month'"
    [touchUi]="false"
    [restoreFocus]="true"
    [calendarHeaderComponent]="datepickerHeader"
    (opened)="pickerOpened.emit()"
    (closed)="onPickerClosed()"
  />
</div>
